import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../UI/Loader";
import Alert from "../../UI/Alert";
import {
  getConfiguracionAplicacionPlantelThunk,
  updateConfiguracionAplicacionPlantelThunk,
} from "../../../store/aplicacionConfigPlantel/aplicacionConfigPlantel.thunks";
import {
  clearAplicacionConfigError,
  resetAplicacionConfigPlantel,
} from "../../../store/aplicacionConfigPlantel/aplicacionConfigPlantel.reducer";

const ConfiguracionAplicacionPlantelForm = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();

  const { config, loading, saving, error } = useSelector(
    (state) => state.aplicacionConfigPlantel,
  );

  const [form, setForm] = useState({
    frase: "",
    etiqueta_si: "",
    etiqueta_no: "",
  });

  useEffect(() => {
    if (!plantelId) return;
    dispatch(getConfiguracionAplicacionPlantelThunk(plantelId));
    return () => dispatch(resetAplicacionConfigPlantel());
  }, [dispatch, plantelId]);

  useEffect(() => {
    if (config) {
      setForm({
        frase: config.frase || "",
        etiqueta_si: config.etiqueta_si || "",
        etiqueta_no: config.etiqueta_no || "",
      });
    }
  }, [config]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!config?.id) return;
    const frase = form.frase.trim();
    const etiquetaSi = form.etiqueta_si.trim();
    const etiquetaNo = form.etiqueta_no.trim();
    if (!frase || !etiquetaSi || !etiquetaNo) {
      toast.error("La frase y ambas etiquetas son obligatorias");
      return;
    }
    const result = await dispatch(
      updateConfiguracionAplicacionPlantelThunk({
        id: config.id,
        frase,
        etiqueta_si: etiquetaSi,
        etiqueta_no: etiquetaNo,
      }),
    );
    if (!result.type.endsWith("/rejected")) {
      toast.success("Configuración actualizada");
    }
  };

  if (loading && !config) {
    return <Loader center text="Cargando configuración..." delay={200} />;
  }

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <h6 className="mb-1 fw-semibold">Configuración del quiz de aplicación</h6>
        <p className="text-secondary-light text-sm mb-3">
          La frase se muestra encima de los botones Sí / No de cada actividad.
        </p>

        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearAplicacionConfigError())}
          />
        )}

        <form onSubmit={handleSubmit} className="row g-3">
          <div className="col-12">
            <label className="form-label fw-medium">
              Frase / pregunta <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              name="frase"
              value={form.frase}
              onChange={handleChange}
              rows={2}
              maxLength={300}
              placeholder="Ej: ¿Te gusta esta actividad?"
              required
            />
          </div>

          <div className="col-md-6">
            <label className="form-label fw-medium">
              Texto del botón "Sí" <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="etiqueta_si"
              value={form.etiqueta_si}
              onChange={handleChange}
              maxLength={50}
              placeholder="Ej: Me identifico"
              required
            />
          </div>

          <div className="col-md-6">
            <label className="form-label fw-medium">
              Texto del botón "No" <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="etiqueta_no"
              value={form.etiqueta_no}
              onChange={handleChange}
              maxLength={50}
              placeholder="Ej: No aplica"
              required
            />
          </div>

          <div className="col-12 d-flex justify-content-end">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={saving || !config?.id}
            >
              {saving ? "Guardando..." : "Guardar cambios"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ConfiguracionAplicacionPlantelForm;
